// extracted by mini-css-extract-plugin
module.exports = {"title":"DuplicatedApplicationTooltip_title__iemqU","link":"DuplicatedApplicationTooltip_link__3qpeY","shareIcon":"DuplicatedApplicationTooltip_shareIcon__1U_nQ"};